export const getFormattedPolicyNumber = (
  policyNumberPrefix: string,
  policyNumber: string | number,
  termCount?: number,
): string => {
  let formattedPolicyNumber = policyNumberPrefix + policyNumber;
  if (termCount !== undefined) {
    formattedPolicyNumber = `${formattedPolicyNumber}-${termCount.toString().padStart(2, '0')}`;
  }
  return formattedPolicyNumber;
};
